import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function ServiceBookTypeChips() {
  const {catalogueApi} = useVehicleFormContext();

  return (
    <Field
      type="chips"
      name="serviceBookType"
      label={i18n.t('general.labels.type')}
      options={catalogueApi?.serviceBookTypeOptions ?? []}
      isDeselectable
    />
  );
}
